module.exports = __webpack_public_path__ + "fonts/PlantinMTPro-Regular.f716bcd5.otf";